module.exports = "/_next/static/images/shinjuku_ramen_top-80295fddf3bca0247cac7a3b2d905f8f.jpg";